import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper';
import React, { useState, useEffect } from "react"
import axios from "axios"

import 'swiper/css';
import 'swiper/css/autoplay';
function SliderHeader() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await axios.get(gameonlineData.root_url + '/wp-json/slider/v1/header')
      setPosts(response.data);
    }
    // category = "accordion";
    fetchPosts();
  }, []);

  console.log(posts)
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      loop={true}
      autoplay={{ delay: 3000 }}
      onSlideChange={() => console.log('slide change')}
      onSwiper={(swiper) => console.log(swiper)}
    >
      {posts.map((post) => {
          return (
            <SwiperSlide className="slider-header__slide"><img src={post.image} /></SwiperSlide>
          );        
        })}
    </Swiper>
  )

}
export default SliderHeader
